module.exports = __webpack_public_path__ + "img/CPC.08566cf7.png";